import { render, staticRenderFns } from "./GlobalBannerNotification.vue?vue&type=template&id=5b943dd2&scoped=true"
import script from "./GlobalBannerNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalBannerNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalBannerNotification.vue?vue&type=style&index=0&id=5b943dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b943dd2",
  null
  
)

export default component.exports